var model = BD.Model.extend({
    organization: BD.belongsTo('Billy.Organization'),
    conversionDate: BD.attr('date'),

    lines: BD.hasMany('Billy.ConversionBalanceLine', 'conversionBalance', { isEmbedded: true })
})

module.exports = model
